<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">User Management</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
<!--                <b-tab v-if="show_customer_tab" title="Customers">-->
<!--                  <Customers></Customers>-->
<!--                </b-tab>-->
                <b-tab title="Roles" v-if="isPortalAdmin">
                  <Groups></Groups>
                </b-tab>
                <b-tab title="Users" active  v-if="isAdministrator">
                  <Users></Users>
                </b-tab>
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">

    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import Customers from "./Customers";
  import Groups from './Groups';
  import Users from './Users';
  import initService from "@/common/api-services/init-service";
    export default {
        name: "User-Management",
      components: {
        Customers,
        Groups,
        Users,
        RouteBreadCrumb,
      },
      mounted() {
        document.title = 'Administrator - User Management'
        if (this.noAccess) {
          this.$router.push("/restricted").catch(() => {});
        }
        //check for portal admn
        try {
          this.isPortalAdmin = initService.getPortalAdminRole();
          this.isAdministrator =
              initService.getUserRoles().includes("PORTAL_ADMIN") ||
              initService.getUserRoles().includes("CARRIER_ADMIN") ||
              initService.getAdministratorRole();
        } catch (e) {}

      },
      data() {
        return {
          show_customer_tab: false,
          isPortalAdmin: false,
          isAdministrator: false,
        }
      }, 
      computed: {
        noAccess() {
          // Determine access based on menu link configuration
          let userRoles = initService.getUserRoles();
          let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

          if (!link) {
            return true;
          } else {
            userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
            return userRoles.length === 0;
          }
        }
      }
    }
</script>

<style scoped>

</style>
